import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { useTabProfesionalViewEquipoColumns } from "../../hooks/TabProfesional/useTabProfesionalViewEquipoColumns";
import { useTabProfesionalViewEquipoRows } from "../../hooks/TabProfesional/useTabProfesionalViewEquipoRows";

export function TabProfesionalViewEquipoDialog({
  open,
  handleCloseDialog,
  evaluacionSelected
}) {
  const { idEvaluacion } = evaluacionSelected;

  const { rows, totalCount, loading} = useTabProfesionalViewEquipoRows({
    idEvaluacion
  });

  const columns = useTabProfesionalViewEquipoColumns();

  return (
    <CustomDialog
      title="Equipo de Profesionales"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      cancelText="Cerrar"
    >
      <DataGridGenerico
        columns={columns}
        rows={rows}
        totalCount={totalCount}
        loading={loading}
        toolbar={false}
      />
    </CustomDialog>
  );
}